<template>
  <div class="container">
    <video
      v-if="mock_live_url"
      id="videoplay"
      ref="videoplay"
      class="video video-js vjs-default-skin"
      v-on:play="onPlay"
      autoplay
      controls
      controlsList="nodownload"
    >
      <source :src="mock_live_url" />
    </video>
  </div>
</template>

<script>
import { storageKeys, loadData } from "@/util/storage";

export default {
  data() {
    return {
      mock_live_url: "",
    };
  },
  mounted() {
    const mockLiveUrl = loadData(storageKeys.mockLiveUrl, "");
    this.mock_live_url = mockLiveUrl;
  },
  methods: {
    onPlay() {},
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.video {
  width: 100%;
  height: auto;
}
</style>
